import React from 'react';
import classnames from 'classnames/bind';
import { Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './chatSuggestions.module.scss';

const classNameBuilder = classnames.bind(styles);

export const suggestions = [
    {
        id: 'landing.pages.form.chat.suggestions.author',
        defaultText: 'Change the author name',
    },
    {
        id: 'landing.pages.form.chat.suggestions.sticky.cta',
        defaultText: 'Add a sticky CTA button',
    },
    {
        id: 'landing.pages.form.chat.suggestions.testimonial',
        defaultText: 'Add a testimonial',
    },
    {
        id: 'landing.pages.form.chat.suggestions.main.image',
        defaultText: 'Re-generate the main image',
    },
    {
        id: 'landing.pages.form.chat.suggestions.headline',
        defaultText: "Let's use a different headline",
    },
    {
        id: 'landing.pages.form.chat.suggestions.revert.last',
        defaultText: 'Revert the last change',
    },
    {
        id: 'landing.pages.form.chat.suggestions.faq.accordion',
        defaultText: 'Add an accordion styled FAQ element',
    },
    {
        id: 'landing.pages.form.chat.suggestions.comparison',
        defaultText: 'Add a comparison table',
    },
];

export const ChatSuggestions = ({
    visibleSuggestions,
    showSuggestions,
    onSuggestionClick,
    onToggleSuggestions,
    isLoading,
}) =>
    showSuggestions ? (
        <div className={classNameBuilder('container', { 'is-loading': isLoading })}>
            <div className={styles.suggestions}>
                {visibleSuggestions.map(suggestion => (
                    <Button
                        className={styles['suggestion-button']}
                        variant={Button.variant.outline}
                        size={Button.size.md}
                        onClick={() => onSuggestionClick(suggestion)}
                    >
                        <FormattedMessage id={suggestion.id} defaultMessage={suggestion.defaultText} />
                    </Button>
                ))}
            </div>
            <button className={styles['toggle-button']} onClick={onToggleSuggestions}>
                <FormattedMessage id="landing.pages.chat.suggestions.hide" defaultMessage="Hide suggestions" />
            </button>
        </div>
    ) : (
        <button className={styles['toggle-button']} onClick={onToggleSuggestions}>
            <FormattedMessage id="landing.pages.chat.suggestions.show" defaultMessage="Show suggestions" />
        </button>
    );
